// The staff dashboard. `f` = { range, from?, to?, store?, mine? } — ranges are resolved on the server
// in Sydney time, so the browser never does date maths.
import { api } from './client.js';

const params = (f = {}) => ({
  range: f.range || 'month',
  ...(f.range === 'custom' ? { from: f.from, to: f.to } : {}),
  ...(f.store ? { store: f.store } : {}),
  ...(f.mine ? { mine: 1 } : {}),
});
const get = (path) => (f) => api.get(`/staff-dashboard/${path}`, { params: params(f) }).then((r) => r.data);

export const fetchDashSummary = get('summary');
export const fetchDashTodo = get('todo');
export const fetchDashActivity = get('activity');
export const fetchDashPerformance = get('performance');
export const fetchDashClients = get('clients');
export const dashExportUrl = (f) => `/api/staff-dashboard/export?${new URLSearchParams(params(f)).toString()}`;
export const fetchTargets = () => api.get('/staff-dashboard/targets').then((r) => r.data);
export const saveTargets = (body) => api.put('/staff-dashboard/targets', body).then((r) => r.data);

// Focus products — what reps should push (Settings → Focus products).
export const fetchFocus = () => api.get('/staff-dashboard/focus').then((r) => r.data);
export const saveFocus = (body) => api.put('/staff-dashboard/focus', body).then((r) => r.data);
export const searchFocusProducts = (store, q) => api.get('/staff-dashboard/focus/products', { params: { store, q } }).then((r) => r.data.products);
